/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.privacy.service.ts.
 */
import {Injectable} from '@angular/core';
import {AppMemoryService} from './app.memory.service';
import {MatDialog} from '@angular/material/dialog';
import {PrivacySettings} from '../models/privacy-settings';
import {AppConfigService} from './app.config.service';
import {BehaviorSubject} from 'rxjs';
import {AppDialogsPrivacyComponent} from '../dialogs/privacy/app.dialogs.privacy.component';

/**
 * Zweck: Beschreibt class AppPrivacyService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppPrivacyService {
  hasSettings = new BehaviorSubject<boolean>(false);
  hasSettings$ = this.hasSettings.asObservable();

  settings: PrivacySettings;
  settings_changed_by_update = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private msvc: AppMemoryService, private cfg: AppConfigService, private dialog: MatDialog) {
    this.load();
    this.init();
  }

/**
 * Beschreibt Methode init und ihren Rückgabevertrag.
 */
  init() {
    if (!this.hasSettings.value || this.settings_changed_by_update) {
      this.settings_changed_by_update = false;
      this.openDialog();
    }
  }

/**
 * Beschreibt Methode openDialog und ihren Rückgabevertrag.
 */
  openDialog() {
    const dref = this.dialog.open(AppDialogsPrivacyComponent, {
      width: '450px',
      data: this.settings,
      disableClose: true
    });

    dref.afterClosed().subscribe(resp => {
      this.settings = resp;
      this.hasSettings.next(true);
      this.save();
    });
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    if (this.msvc.has('AppPrivacyService_settings', 'BROWSER')) {
      const sett = new PrivacySettings();
      const cfgsett = this.msvc.get('AppPrivacyService_settings', 'BROWSER');

      Object.keys(sett).forEach(k => {
        if (cfgsett[k] === undefined) {
          this.settings_changed_by_update = true;
        } else {
          sett[k] = cfgsett[k];
        }
      });

      this.settings = sett;
      this.hasSettings.next(true);

    } else {
      this.settings = new PrivacySettings();
    }
  }

/**
 * Beschreibt Methode save und ihren Rückgabevertrag.
 */
  save() {
    this.msvc.set('AppPrivacyService_settings', this.settings, false, 'BROWSER');
  }
}
